import React from 'react';

const CPContext = React.createContext('');

export const CPProvider = CPContext.Provider;
export const CPConsumer = CPContext.Consumer;
